import {
  ORGANIZATION_STATUS_LABEL,
  ORGANIZATION_STATUS_TONE,
  PAYMENT_HEALTH_LABEL,
  PAYMENT_HEALTH_TONE,
  VALUE_UNRESOLVED,
} from '../../Consts/backoffice.const';
import { OrganizationListItemResponse } from '../../Interfaces/api/backoffice/organization.interface';
import { StatusTone } from '../../Modules/Shared/Types/status-tone.type';

export class OrganizationSummary {
  id = '';
  name: string | null = null;
  domain: string | null = null;
  avyna_nickname: string | null = null;
  status: string | null = null;
  contact_email: string | null = null;
  billing_currency: string | null = null;
  entra_tenant_id: string | null = null;
  tenant_health_status: string | null = null;
  admin_consent_granted_at: string | null = null;
  installed_at: string | null = null;
  directory_reconciled_at: string | null = null;
  root_missing_flagged_at: string | null = null;
  created_at: string | null = null;
  billing_email: string | null = null;
  billing_email_source: string | null = null;
  billing_email_is_inherited = false;
  plan_name: string | null = null;
  mrr = 0;
  payment_health: string | null = null;
  admin_contact_email: string | null = null;
  last_invoice_status: string | null = null;
  last_invoice_date: string | null = null;
  open_invoice_count = 0;
  failed_payment_count = 0;

  constructor(data: Partial<OrganizationListItemResponse> = {}) {
    Object.assign(this, data);
  }

  get displayName(): string {
    return this.name || this.avyna_nickname || this.domain || this.id;
  }

  get statusLabelKey(): string {
    return this.status ? (ORGANIZATION_STATUS_LABEL[this.status] ?? this.status) : VALUE_UNRESOLVED;
  }

  get statusTone(): StatusTone {
    return this.status ? (ORGANIZATION_STATUS_TONE[this.status] ?? 'neutral') : 'neutral';
  }

  get healthLabelKey(): string {
    return this.payment_health
      ? (PAYMENT_HEALTH_LABEL[this.payment_health] ?? this.payment_health)
      : VALUE_UNRESOLVED;
  }

  get healthTone(): StatusTone {
    return this.payment_health
      ? (PAYMENT_HEALTH_TONE[this.payment_health] ?? 'neutral')
      : 'neutral';
  }

  get rootIsMissing(): boolean {
    return this.root_missing_flagged_at !== null;
  }

  get needsAttention(): boolean {
    return this.open_invoice_count > 0 || this.failed_payment_count > 0;
  }
}
